import { render, staticRenderFns } from "./ThreadList.vue?vue&type=template&id=e5d98818&scoped=true"
import script from "./ThreadList.vue?vue&type=script&lang=js"
export * from "./ThreadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d98818",
  null
  
)

export default component.exports